<div>
  <h2 mat-dialog-title>{{ 'registration_modals.edit' | translate }} {{ dataToEdit | titlecase }}</h2>
  <div class="scrollable-content">
    <ng-container [ngSwitch]="dataToEdit">

      <div class="overview" *ngSwitchCase="'motivation'">
        <app-input-area (text)="sendText($event)" [defaultText]="editedValue" [isEditable]="true"
                        [withSubmit]="false"></app-input-area>
      </div>

      <div *ngSwitchCase="'languages'">
        <app-dropdown
          [items]="languages"
          bindLabel="name"
          bindValue="name"
          [clearable]="false"
          [multiple]="true"
          [formControl]="languageCtrl"
          placeholder="{{ 'login_page.select_language' | translate }}"
        >
          <ng-template #optionTpl let-language>
            <div class="language-option" style="display:flex;align-items:center;gap:.5rem;">
              <img
                [src]="getFlagSrc(language?.name ?? language)"
                [alt]="(language?.name ?? language) + ' flag'"
                style="width:1rem;height:1rem;border-radius:2px;"
              />
              <span>{{ language?.name ?? language }}</span>
            </div>
          </ng-template>
        </app-dropdown>

        <mat-chip-set class="selected-language-set">
          <mat-chip *ngFor="let language of selectedLanguages"
                    removable="true"
                    (removed)="removeLanguage(language)"
                    class="language-chip">

            <div class="chip-content">
              <div class="left-content">
                <img [src]="getFlagSrc(language)" class="flag-icon" alt="{{ language }} flag"/>
                <span class="language-name">{{ language }}</span>
              </div>
              <button matChipRemove class="remove-btn">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </mat-chip>

        </mat-chip-set>
      </div>

      <div *ngSwitchDefault>
        <p>{{ 'errors.no_valid_section' | translate }}</p>
      </div>
    </ng-container>
  </div>

  <div class="buttons">
    <app-button (click)="save()" [isFullWidth]="true" [label]="'shared.save' | translate" [size]="ButtonSize.LARGE"
                [state]="ButtonState.REGULAR" [type]="ButtonType.PRIMARY"></app-button>
    <app-button (click)="cancel()" [isFullWidth]="true" [label]="'shared.cancel' | translate" [size]="ButtonSize.LARGE"
                [state]="ButtonState.REGULAR" [type]="ButtonType.SECONDARY"></app-button>
  </div>
</div>
